var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Modal, Button, Space } from "antd";
/**
 * 通用模态框容器组件
 * 支持 footer 左侧按钮和右侧两个按钮，支持自定义宽高和内容内边距
 */
var ContainerModal = function (_a) {
    var _b, _c, _d;
    var title = _a.title, visible = _a.visible, _e = _a.width, width = _e === void 0 ? 800 : _e, _f = _a.height, height = _f === void 0 ? 600 : _f, children = _a.children, _g = _a.footerLeftButtons, footerLeftButtons = _g === void 0 ? [] : _g, _h = _a.footerRightButtons, footerRightButtons = _h === void 0 ? [] : _h, _j = _a.contentPadding, contentPadding = _j === void 0 ? 16 : _j, onCancel = _a.onCancel, onTitleClick = _a.onTitleClick, _k = _a.modalProps, modalProps = _k === void 0 ? {} : _k;
    // 渲染左侧按钮
    var renderLeftButtons = function () {
        if (!footerLeftButtons || footerLeftButtons.length === 0) {
            return null;
        }
        // 如果是 React 节点数组，直接渲染
        if (Array.isArray(footerLeftButtons) &&
            footerLeftButtons.length > 0 &&
            React.isValidElement(footerLeftButtons[0])) {
            return _jsx(Space, { children: footerLeftButtons });
        }
        // 如果是按钮配置数组
        return (_jsx(Space, { children: footerLeftButtons.map(function (button) {
                if (button.hidden)
                    return null;
                var buttonType = button.type === "danger" ? "default" : button.type;
                return (_jsx(Button, __assign({ type: buttonType, danger: button.type === "danger", icon: button.icon, loading: button.loading, disabled: button.disabled, onClick: button.onClick }, { children: button.text }), button.key));
            }) }));
    };
    // 渲染右侧按钮（最多两个）
    var renderRightButtons = function () {
        if (!footerRightButtons || footerRightButtons.length === 0) {
            return null;
        }
        // 限制最多两个按钮
        var buttonsToRender = footerRightButtons.slice(0, 2);
        // 如果是 React 节点数组，直接渲染
        if (Array.isArray(buttonsToRender) &&
            buttonsToRender.length > 0 &&
            React.isValidElement(buttonsToRender[0])) {
            return _jsx(Space, { children: buttonsToRender });
        }
        // 如果是按钮配置数组
        return (_jsx(Space, { children: buttonsToRender.map(function (button) {
                if (button.hidden)
                    return null;
                var buttonType = button.type === "danger" ? "default" : button.type;
                return (_jsx(Button, __assign({ type: buttonType, danger: button.type === "danger", icon: button.icon, loading: button.loading, disabled: button.disabled, onClick: button.onClick }, { children: button.text }), button.key));
            }) }));
    };
    // 构建 Footer
    var renderFooter = function () {
        var leftButtons = renderLeftButtons();
        var rightButtons = renderRightButtons();
        // 如果没有任何按钮，返回 null（隐藏 footer）
        if (!leftButtons && !rightButtons) {
            return null;
        }
        return (_jsxs("div", __assign({ style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            } }, { children: [_jsx("div", { children: leftButtons }), _jsx("div", { children: rightButtons })] })));
    };
    // 构建 Modal body 样式
    // 计算 body 高度：总高度减去 header（约 55px）和 footer（约 53px）
    var bodyHeight = typeof height === "number" ? Math.max(height - 55 - 53, 0) : undefined;
    var toCssUnit = function (v) {
        return typeof v === "number" ? "".concat(v, "px") : v;
    };
    var resolvePadding = function (p) {
        var _a, _b, _c, _d;
        if (p === undefined)
            return undefined;
        if (typeof p === "number" || typeof p === "string") {
            return toCssUnit(p);
        }
        var t = toCssUnit((_a = p.top) !== null && _a !== void 0 ? _a : p.vertical);
        var r = toCssUnit((_b = p.right) !== null && _b !== void 0 ? _b : p.horizontal);
        var b = toCssUnit((_c = p.bottom) !== null && _c !== void 0 ? _c : p.vertical);
        var l = toCssUnit((_d = p.left) !== null && _d !== void 0 ? _d : p.horizontal);
        return [t !== null && t !== void 0 ? t : "0", r !== null && r !== void 0 ? r : "0", b !== null && b !== void 0 ? b : "0", l !== null && l !== void 0 ? l : "0"].join(" ");
    };
    var bodyStyle = __assign({ padding: resolvePadding(contentPadding !== null && contentPadding !== void 0 ? contentPadding : 16), height: bodyHeight === undefined ? undefined : "".concat(bodyHeight, "px"), overflow: "auto" }, (_b = modalProps.styles) === null || _b === void 0 ? void 0 : _b.body);
    // 处理标题点击事件
    var renderTitle = function () {
        if (title && onTitleClick) {
            var handleKeyDown = function (e) {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onTitleClick();
                }
            };
            return (_jsx("button", __assign({ type: "button", onClick: onTitleClick, onKeyDown: handleKeyDown, style: {
                    cursor: "pointer",
                    userSelect: "none",
                    background: "none",
                    border: "none",
                    padding: 0,
                    margin: 0,
                    font: "inherit",
                    color: "inherit",
                    textAlign: "inherit",
                    width: "100%",
                } }, { children: title })));
        }
        return title;
    };
    return (_jsx(Modal, __assign({ title: renderTitle(), open: visible, width: width, onCancel: onCancel, footer: renderFooter(), styles: __assign(__assign({}, modalProps.styles), { body: bodyStyle, header: __assign({}, (_c = modalProps.styles) === null || _c === void 0 ? void 0 : _c.header), footer: __assign({}, (_d = modalProps.styles) === null || _d === void 0 ? void 0 : _d.footer) }), style: __assign(__assign({}, (typeof height === "string" ? { height: height } : {})), modalProps.style) }, modalProps, { children: children })));
};
export default ContainerModal;
